import { Availability } from './availability';
import { CouponType } from './coupon-type';
import { TranslatedText } from './translated-text';

export class Coupon {
  id: string;
  couponId: string;
  code: string;
  name: TranslatedText;
  description: TranslatedText;
  availability: Availability[];
  isEnabled: boolean;
  type: CouponType;
  autoApply: boolean;
  products?: any[];
  cart: any;

  constructor(id: string, code: string, name: string, description: string, type: CouponType, products?: any[]) {
    this.id = id;
    this.couponId = id;
    this.code = code;
    this.name = new TranslatedText(name);
    this.description = new TranslatedText(description);
    this.availability = [new Availability()];
    this.isEnabled = true;
    this.autoApply = false;
    this.type = type;
    this.products = products;

    if (type === CouponType.PRODUCT || type === CouponType.VOUCHER) {
      this.products = [];
    } else if (type === CouponType.CART) {
      this.cart = {};
    }
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
